export default "__VITE_ASSET__GDvNisQk__"